import { roundOffAndFormatNumberWithCurrency } from '../../../../../utils/utils'
import { EventNames } from '../../../../../types/misc.types'
import { postCTA, trackEvent } from '../../../../../utils/appBridge'
import Button from '../../../../ui-components/Button'
import { useBottomSheet } from '../../../../../state-management/contexts/BottomSheetContext'
import { hasEliteConsentText } from '../../../EliteConsentTextContent'
import type { EliteConsentTextItem } from '../../../../../types/misc.types'
import UpgradeAppContent from '../../../../BottomSheetComponents/UpgradeAppContent'
import { useEliteBuyCtaExtras } from '../../../EliteBuyCtaExtrasContext'
interface RebalancingPlanSectionProps {
  numberOfFundsToRebalance: number
  missedGains: number
  cta: Record<any, any> | null
  isEliteButtonDisabled: boolean
  isConsentChecked: boolean
  isForceUpdateRequired: boolean
  consentText?: string
  consentTextList?: EliteConsentTextItem[]
  screenType?: string
}

export const RebalancingPlanSection = ({
  numberOfFundsToRebalance,
  missedGains,
  cta,
  isEliteButtonDisabled,
  isConsentChecked,
  isForceUpdateRequired,
  consentText,
  consentTextList,
  screenType = 'EliteLandingPageV5'
}: RebalancingPlanSectionProps) => {
  const eliteBuyCtaExtras = useEliteBuyCtaExtras()
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  const hasConsent = hasEliteConsentText(consentTextList, consentText)
  const isButtonDisabled = isEliteButtonDisabled || (hasConsent && !isConsentChecked)

  if (numberOfFundsToRebalance <= 0) return null

  return (
    <div className='px-5 mt-10'>
      <span className='text-sm font-medium inline-block'>
        SEBI-registered experts analysed your portfolio <br /> and found:
      </span>
      <div
        style={{
          backgroundImage: `url('/images/elite-button-bg.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
        className='bg-white p-5 rounded-2xl mt-4'
      >
        <div className={`${missedGains > 0 ? 'text-black' : 'text-orange30'} font-medium`}>
          {numberOfFundsToRebalance} {numberOfFundsToRebalance > 1 ? 'funds' : 'fund'} to rebalance
        </div>
        {missedGains > 0 && (
          <div className='text-orange30 text-base'>{roundOffAndFormatNumberWithCurrency(missedGains)} missed gains</div>
        )}
      </div>
      <div className='text-grey40 text-13 mt-3'>
        Know which funds to exit and switch to better performing ones, with your rebalancing plan.
      </div>
      <div className='relative z-0 mt-[50px] mb-6'>
        <Button
          isFullWidth={true}
          disabled={isEliteButtonDisabled}
          onClick={() => {
            if (hasConsent && !isConsentChecked) return
            else if (isForceUpdateRequired) openBottomSheet(<UpgradeAppContent onDismiss={closeBottomSheet} />)
            else if (cta && !isEliteButtonDisabled) {
              trackEvent({
                eventName: EventNames.UserClicked,
                payload: {
                  ...eliteBuyCtaExtras,
                  eventId: 'UnlockPlanWithEliteClicked_Rebalancing',
                  ScreenName: screenType || 'EliteLandingPageV5',
                  screenType: screenType || 'EliteLandingPageV5',
                  buttonLabel: 'Unlock plan with Elite'
                }
              })
              postCTA(JSON.stringify(cta))
            }
          }}
          buttonClassName={`relative bg-black text-white rounded-xl text-center px-6 py-5 z-20 font-medium !h-[52px] !text-[14px] ${isButtonDisabled ? '!bg-[#D1D6D6]' : ''}`}
        >
          Unlock plan with Elite
        </Button>
        <div className='absolute top-[-30px] text-13 font-medium pt-1 text-center bg-[#F7CB88] rounded-xl inset-0 z-10'>
          Your personalised rebalancing plan is ready
        </div>
      </div>
    </div>
  )
}
